module.exports = __webpack_public_path__ + "img/FR19229.0fee2e84.png";